import { cn } from "@/lib/utils";

export type ComplaintStatus =
  | "PENDING"
  | "ASSIGNED"
  | "INSPECTION"
  | "WAITING_PARTS"
  | "REPAIRING"
  | "TESTING"
  | "COMPLETED"
  | "DELIVERED"
  | "CANCELLED";

export type Priority = "LOW" | "MEDIUM" | "HIGH" | "URGENT";

const STATUS_LABEL: Record<ComplaintStatus, string> = {
  PENDING: "Pending",
  ASSIGNED: "Assigned",
  INSPECTION: "Inspection",
  WAITING_PARTS: "Waiting Parts",
  REPAIRING: "Repairing",
  TESTING: "Testing",
  COMPLETED: "Completed",
  DELIVERED: "Delivered",
  CANCELLED: "Cancelled",
};

const STATUS_CLASSES: Record<ComplaintStatus, string> = {
  PENDING: "bg-muted text-muted-foreground",
  ASSIGNED: "bg-primary/10 text-primary",
  INSPECTION: "bg-primary/10 text-primary",
  WAITING_PARTS: "bg-accent/15 text-accent-foreground",
  REPAIRING: "bg-accent/15 text-accent-foreground",
  TESTING: "bg-primary/10 text-primary",
  COMPLETED: "bg-success/15 text-success",
  DELIVERED: "bg-success/15 text-success",
  CANCELLED: "bg-destructive/10 text-destructive",
};

export function StatusBadge({ status }: { status: ComplaintStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        STATUS_CLASSES[status]
      )}
    >
      {STATUS_LABEL[status]}
    </span>
  );
}

const PRIORITY_CLASSES: Record<Priority, string> = {
  LOW: "bg-muted text-muted-foreground",
  MEDIUM: "bg-primary/10 text-primary",
  HIGH: "bg-accent/15 text-accent-foreground",
  URGENT: "bg-destructive/10 text-destructive",
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
        PRIORITY_CLASSES[priority]
      )}
    >
      {priority}
    </span>
  );
}
